<p-toolbar styleClass="mb-4" reflow="true">
    <ng-template pTemplate="left"></ng-template>
    <ng-template pTemplate="right">
      <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
        class="p-button-help"></button>
        <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
        class="p-button-info ml-3"></button>
      <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
    </ng-template>
  </p-toolbar>
<p-toast></p-toast>
<div class="app-fullPaymentChallanDetailsTable-container">
    <p-card styleClass="p-card-shadow">
        <!-- <h5 class="mt-0">Full Payment Details</h5> -->
        <div class="card dashboardTable">
            <p-table #fullPaymentChallanDetailsTable [value]="fullPaymentTableData" [rows]="10" [paginator]="true"
                [globalFilterFields]="[
          'AppId',
          'CreditDateTime',
          'TransferMode',
          'PendingCompletedDays',
          'Status_Ar',
          'Deposit_Amount',
          'FromAccountNumber',
          'VirtualAccount'
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0"> {{'FULL_PAYMENT_CHALLAN_HEADER'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="
                  fullPaymentChallanDetailsTable.filterGlobal(
                    $any($event.target).value,
                    'contains'
                  )
                " placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="AppId">
                             {{'APP_ID'| translate}}
                            <p-columnFilter type="text" field="AppId" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="CreditDateTime">
                            {{'CREDIT_DATE_TIME'| translate}}
                            <p-columnFilter type="text" field="CreditDateTime" display="menu"></p-columnFilter>
                            <p-sortIcon field="CreditDateTime"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TransferMode">
                            {{'TRANSFER_MODE'| translate}}
                            <p-columnFilter type="text" field="TransferMode" display="menu"></p-columnFilter>
                            <p-sortIcon field="TransferMode"></p-sortIcon>
                        </th>
                        <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS'| translate}}
                            <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
                            <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Status_Ar">{{'CURRENT_STATUS'| translate}}
                            <p-columnFilter type="text" field="Status_Ar" display="menu"></p-columnFilter>
                            <p-sortIcon field="Status_Ar"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Deposit_Amount">
                            {{'DEPOSIT_AMOUNT'| translate}}
                            <p-columnFilter type="text" field="Deposit_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="Deposit_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FromAccountNumber">
                            {{'ACCOUNT_NUMBER'| translate}}
                            <p-columnFilter type="text" field="FromAccountNumber" display="menu"></p-columnFilter>
                            <p-sortIcon field="FromAccountNumber"></p-sortIcon>
                        </th>
                        <th pSortableColumn="VirtualAccount">
                            {{'VIRTUAL_ACCOUNT'| translate}}
                            <p-columnFilter type="text" field="VirtualAccount" display="menu"></p-columnFilter>
                            <p-sortIcon field="VirtualAccount"></p-sortIcon>
                        </th>

                        <th pSortableColumn="">{{'ACTION'| translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <td>{{ product.AppId }}</td>
                        <!-- <td>{{ product.CreditDateTime | date:"medium" }}</td> -->
                        <td>{{ product.CreditDateTime }}</td>
                        <td>{{ product.TransferMode }}</td>
                        <td>{{ product.Deposit_Amount }}</td>
                        <td>{{ product.PendingCompletedDays }}</td>
                        <td>{{ product.Status_Ar }}</td>
                        <td>{{ product.FromAccountNumber }}</td>
                        <td>{{ product.VirtualAccount }}</td>
                        <td>
                            <button pButton pRipple type="button" (click)="takeAction(product)" icon="pi pi-pencil"
                                class="p-button-rounded p-button-text"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}}
                        {{ fullPaymentTableData ? fullPaymentTableData.length : 0 }} {{'FULL_PAY_CHALLAN_DETAIL'| translate}}
                    </div>
                    <div class="flex  justify-content-between flex-column ">
                        <div class="flex">
                            <div
                                style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'PENDING_BY_ONE_DAY'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'APROVED_ON_TIME'| translate}}
                        </div>
                        <div class="flex">
                            <div
                                style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;">
                            </div>{{'DELAYED_APPROVED'| translate}}
                        </div>
                    </div>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>

<!-- <p-confirmDialog [style]="{ width: '400px' }"></p-confirmDialog> -->

<p-dialog header="{{'FARMER_FULL_PAY_ACKNOWLEGEMENT'| translate}}" [(visible)]="displayDialog" [modal]="true"
    [style]="{ width: '60%', height: '60%' }" [maximizable]="false" [draggable]="false" [resizable]="false"
    (onHide)="onCloseDialog()">
    <div class="card acknowledgementCard">
        <div class="p-2">
            <h5>{{'APPLICATION_ID'| translate}}:<b> {{ appId }}</b></h5>
        </div>
        <div class="p-fluid p-formgrid grid" style="margin: 5px">
            <div class="field col-12 md:col-6">
                <textarea id="description" [(ngModel)]="remarks" placeholder="{{'REMARKS'| translate}}" pInputTextarea required rows="3"
                    cols="20" class="mr-3"></textarea>
            </div>
            <div class="field col-12 md:col-6">
                <h6>{{'ACKNOWLEDGEMENT'| translate}}</h6>
                <p-dropdown [options]="acknowledgement" [(ngModel)]="selectedAcknowledgement"
                    placeholder="{{'SELECT_A_VALUE'| translate}} " optionLabel="val" [style]="{ width: '20vw' }"></p-dropdown>
            </div>
        </div>
    </div>

    <div class="flex justify-content-around mt-3">
        <button (click)="onSubmitRemark()" pButton pRipple type="submit" label="{{'SUBMIT'| translate}}"
            class="p-button-success mr-2 mb-2" [disabled]="remarks == '' || selectedAcknowledgement == null"></button>
        <button (click)="onCloseDialog()" pButton pRipple type="button" label="{{'CANCEL'| translate}}"
            class="p-button-danger mr-2 mb-2"></button>
    </div>
</p-dialog>